import { render } from "./OptionOne.vue?vue&type=template&id=54c3da30&scoped=true"
import script from "./OptionOne.vue?vue&type=script&lang=js"
export * from "./OptionOne.vue?vue&type=script&lang=js"

import "./OptionOne.vue?vue&type=style&index=0&id=54c3da30&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54c3da30"]])

export default __exports__